import { step } from '@js/util/animate.js'

export default Alpine => {
  Alpine.magic('step', () => step)
}
